var angular = require('angular');
var _module = angular.module('benoit');

_module.directive('numbersOnly', function numbersOnly() {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function numbersOnlyLink($scope, $elem, $attrs, modelCtrl) {
            modelCtrl.$parsers.push(function numbersOnlyParser(value) {
                if (value == undefined) return '';

                var transValue = String(value).replace(/[^0-9]/g, '');

                if(value !== transValue) {
                    modelCtrl.$setViewValue(transValue);
                    modelCtrl.$render();
                }

                return transValue;
            });
        }
    };
});
